<script setup>
import TheSelectMultiple from '@shared-components/ui/selects/TheSelectMultiple.vue'
import {computed, watch, defineModel, defineProps} from 'vue'
import {arraysEqual, findInvalidEmails, normalizeEmails} from '@shared/utils/helpers'

const modelValue = defineModel({required: true, default: []})

defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: null,
  },
})

const invalidEmails = computed(() => findInvalidEmails(modelValue.value))

const invalidEmailsMessage = computed(() => {
  if (invalidEmails.value.length === 0) {
    return ''
  }

  return `Invalid email format: ${invalidEmails.value.join(', ')}`
})

watch(
  () => modelValue.value,
  newValues => {
    const normalizedValues = normalizeEmails(newValues)
    if (!arraysEqual(newValues, normalizedValues)) {
      modelValue.value = normalizedValues
    }
  },
  {deep: true},
)
</script>

<template>
  <the-select-multiple
    :options="modelValue"
    v-model="modelValue"
    :create_option="true"
    :show_no_results="false"
    :show_options="false"
    mode="tags"
    :can-add-tags="true"
    :disabled="disabled"
    :required="required"
    :placeholder="placeholder"
  />
  <input v-if="invalidEmails.length > 0" class="d-none" required />
  <div v-if="invalidEmailsMessage" class="text-danger custom mt-2 fs-4">{{ invalidEmailsMessage }}</div>
</template>
